/**
 * Header - View component for application header
 * Pure presentation component with no business logic
 */

import React from 'react';

export default function Header() {
  return <h1>FMC Grader</h1>;
}
